import { watch } from 'vue'
import { createI18n } from 'vue-i18n'
import de from './locales/de.json'
import en from './locales/en.json'
import { syncDocumentLang } from '../utils/documentLang'

// Get browser language
const getBrowserLanguage = () => {
  const lang = navigator.language || navigator.userLanguage
  if (lang.startsWith('de')) {
    return 'de'
  }
  return 'en'
}

// Get saved language preference or use browser language
const getSavedLanguage = () => {
  const saved = localStorage.getItem('language')
  if (saved && (saved === 'de' || saved === 'en')) {
    return saved
  }
  return getBrowserLanguage()
}

// Check if language was already selected (to show initial dialog only once)
const wasLanguageSelected = () => {
  return localStorage.getItem('language_selected') === 'true'
}

export const markLanguageSelected = () => {
  localStorage.setItem('language_selected', 'true')
}

const i18n = createI18n({
  legacy: false,
  locale: getSavedLanguage(),
  fallbackLocale: 'de',
  messages: {
    de,
    en
  }
})

watch(i18n.global.locale, (locale) => syncDocumentLang(locale), { immediate: true })

// Apply browser language silently on first visit (no blocking overlay)
if (!wasLanguageSelected()) {
  markLanguageSelected()
}

// Export helper to check if initial dialog should be shown
export const shouldShowLanguageDialog = () => {
  return false
}

export default i18n
